import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopToolbar from "./TopToolbar";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "./Loader";

export default function AppLayout() {
    const { user } = useAuth();
    if (user === null) return (
        <div className="min-h-screen flex items-center justify-center bg-black">
            <Loader label="Initializing" />
        </div>
    );
    if (!user) return <Navigate to="/login" replace />;

    return (
        <div className="min-h-screen flex bg-black">
            <div className="print:hidden">
                <Sidebar />
            </div>
            <main className="flex-1 min-w-0 overflow-x-hidden">
                <TopToolbar />
                <div className="animate-fade-in">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
